<template>
  <v-app :style="{background: $vuetify.theme.themes.light.contrast}">
    <router-view></router-view>
  </v-app>
</template>

<script>
import { fmessaging } from './plugins/firebase';

export default {
  name: 'App',
  components: {},
  data: () => ({
    notificationAudio: null,
  }),
  mounted() {
    this.notificationAudio = new Audio(require('./assets/new-order-alert.mp3'));

    fmessaging.onMessage((payload) => {
      this.notificationAudio.play();
      this.$toast.show(
        payload.notification.body,
        payload.notification.title,
        {
          layout: 2,
          image: "./logo.png",
          position: 'topRight',
          timeout: 0
        }
      );
    });
  },
};
</script>
<style scoped></style>